import type { TFunction } from "i18next";

/**
 * DFT-0044: humanized display text for the raw domain enums Bay Hire's list/queue tables and
 * their Filters panels both render - `bayPreference`/`paymentType`/`status` were humanized on the
 * Request Detail page (FE-43, FE-19/36) but not in the list/queue rows or the filter dropdown
 * options themselves, so a request still showed "INSIDE_PORT"/"MONTHLY" there. Same
 * `t(key.value, {defaultValue: value})` convention as the detail page - namespaced by the raw
 * value, falling back to it if a translation is ever missing, so this can never render blank for a
 * value the labels haven't caught up with yet.
 *
 * Deliberately NOT used to overwrite the row's own `bayPreference`/`paymentType`/`status` fields -
 * those still feed the Update Request flow's initial form values (as the raw enum a `select`
 * expects) and the vendor kebab's action guards. Callers add a SEPARATE `*Label` field for display
 * and point the table header's `field` at that instead, exactly the same pattern `statusLabel`
 * already established for columns.tsx's status column.
 */
export const bayHirePreferenceLabel = (t: TFunction, value?: string | null): string =>
  t(`bay-hire.bayPreference.${value}`, { defaultValue: value ?? "-" });

export const bayHirePaymentTypeLabel = (t: TFunction, value?: string | null): string =>
  t(`bay-hire.paymentType.${value}`, { defaultValue: value ?? "-" });

export const bayHireStatusLabel = (t: TFunction, value?: string | null): string =>
  t(`bay-hire.status.${value}`, { defaultValue: value ?? "-" });

/** Builds a Filters panel `SelectField`'s `{ value, label }` options from raw enum values. */
export const toBayHireSelectOptions = (
  values: readonly string[],
  labelFn: (t: TFunction, value: string) => string,
  t: TFunction,
): { value: string; label: string }[] =>
  values.map((value) => ({ value, label: labelFn(t, value) }));
